export default "__VITE_ASSET__67234430__"